import 'react-datepicker/dist/react-datepicker.css';

import { useCallback } from 'react';

import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { ActivityFilter, ActivityList, GolferSelection } from '@blocks';
import { useActivityList } from '@hooks';
import { useTranslate } from '@i18n';
import { currentActivityIdAtom } from '@store';
import { Box, Button, Screen, Stack, u } from '@ui';

import { LINKS } from '../../utils/routes';

import * as css from './ActivityOverview.css';

export function ActivityOverviewScreen() {
    const navigate = useNavigate();
    const t = useTranslate();
    const currentActivityId = useAtomValue(currentActivityIdAtom);
    const startNewActivity = useCallback(async () => {
        navigate(LINKS.createActivity());
    }, [navigate]);
    const {
        studentId,

        containerRef,
        bottomRef,

        lastSelectedActivityId,
        persistLastSelectedActivityId,

        activities,
        totalActivities,
        isLoadingActivities,
        isFetchingNextPage,
        hasNextPage,
        fetchNextPage,
        refetch,
    } = useActivityList();
    const handleClose = useCallback(() => {
        navigate(LINKS.getFullActivity());
    }, [navigate]);

    return (
        <Screen.Root
            title="Activity overview"
            header={{
                static: {
                    end: (
                        <>
                            <Button variant="primary" onClick={startNewActivity}>
                                {t('activity_overview.start_new')}
                            </Button>
                            <Button variant="secondary" onClick={handleClose}>
                                {t('generic_ui.close')}
                            </Button>
                        </>
                    ),
                },
            }}
            fixed
        >
            <Screen.Column span="6/20" sticky>
                <ActivityFilter
                    totalActivities={totalActivities}
                    numberOfActivities={activities?.length}
                    golfers={<GolferSelection studentId={studentId} getOverviewLink={LINKS.getOverview} />}
                />
            </Screen.Column>
            <Screen.Column span="14/20">
                <div className={css.scrollable}>
                    <Stack gap={u(2.5)}>
                        <ActivityList
                            ref={containerRef}
                            lastSelectedActivityId={lastSelectedActivityId}
                            isLoading={isLoadingActivities || isFetchingNextPage}
                            activities={activities}
                            showNoResultsMessage={activities.length === 0}
                            currentActivityId={currentActivityId}
                            hasNextPage={hasNextPage}
                            persistLastSelectedActivityId={persistLastSelectedActivityId}
                            fetchNextPage={fetchNextPage}
                            getActivityLink={LINKS.getActivity}
                            retry={refetch}
                        >
                            <Box width="100%" style={{ height: 40 }} ref={bottomRef} />
                        </ActivityList>
                    </Stack>
                </div>
            </Screen.Column>
        </Screen.Root>
    );
}
